import { useEffect, useState } from 'react';
import CKEditor from '../../ckEditor';
import { useNavigate, useParams } from 'react-router';
import { useCreateFlashcardWithSetMutation, useGetFlashcardMutation, useSaveFlashcardMutation, useUpdateFlashcardMutation } from '../../../features/authentication/qSetApiSlice';
import CustomToast from '../../../components/Toast';
import CreateFlashcardSetModel from '../pages/flashcardSets/components/CreateFlashcardSetModal';
import { bytesToBase64 } from '../../../utils/pdfUtils';
import ActivityTypes from '../../../enums/activityTypes';
import { UrlFormatter } from '../../../utils/urlFormatter';

const AddFlashCard = () => {
  const {setId, flashcardId} = useParams();
  const [definition, setDefinition] = useState('');
  const [term, setTerm] = useState('New Vocabulary');
  const [isOpenCreateFlashcardSet, setIsOpenCreateFlashcardSet] = useState(false);
  const [dateTimeBasedUniqueKey, setDateTimeBasedUniqueKey] = useState(new Date().getTime().toString());
  const [saveFlashcard] = useSaveFlashcardMutation();
  const [getFlashcard] = useGetFlashcardMutation();
  const [updateFlashcard] = useUpdateFlashcardMutation();
  const [createFlashcardWithSet] = useCreateFlashcardWithSetMutation();
  const navigate = useNavigate();

  useEffect(() => {
    if(flashcardId){
      getFlashcardAsync();
    }
  }, [flashcardId]);

  const getFlashcardAsync = async () =>{
    const options = {
      id:flashcardId
    };
    const response = await getFlashcard(options).unwrap();
    setTerm(response.name);
    setDefinition(response.description);
    setDateTimeBasedUniqueKey(new Date().getTime().toString());
  };

  const handleSave = () =>{
    if(term.length == 0){
      CustomToast('Vocabulary Term cannot be empty.','warning');
      return;
    }
    if(definition.length == 0){
      CustomToast('Definition cannot be empty.','warning');
      return;
    }
    if(flashcardId){
      updateFlashcardAsync();
      return;
    }
    if(setId)
      addFlashcardAsync(setId);
    else
      setIsOpenCreateFlashcardSet(true);
  };

  const addFlashcardAsync = async (setId) => {
    const options={
      setId:setId,
      params:{
        term:term,
        definition:bytesToBase64(new TextEncoder().encode(UrlFormatter.ReplaceBaseUrlWithDots(definition)))
      }
    };
    await saveFlashcard(options).unwrap();
    CustomToast('Flashcard addedd successfully','success');
    setDateTimeBasedUniqueKey(new Date().getTime().toString());
    navigate(`/mycontent/flashcardsets/${setId}/flashcards`);
  };

  const updateFlashcardAsync = async ()=>{
    const options={
      id:flashcardId,
      params:{
        term:term,
        definition:bytesToBase64(new TextEncoder().encode(definition))
      }
    };
    await updateFlashcard(options).unwrap();
    CustomToast('Flashcard addedd successfully','success');
    navigate(`/mycontent/flashcardsets/${setId}/flashcards`);
  };

  const createFlashcardWithSetAsync = async (setName) => {
    const option = {
      description: setName,
      activityType: ActivityTypes.FlashCard,
      term:term,
      definition:bytesToBase64(new TextEncoder().encode(definition))
    };

    try {
      const result = await createFlashcardWithSet(option);
      if (result.data) {
        CustomToast('Flash Card Set Created', 'success');
        setIsOpenCreateFlashcardSet(false);
        navigate(`/mycontent/flashcardsets/${result.data}/flashcards`);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className='bg-white mb-4 rounded-4 p-4' key={dateTimeBasedUniqueKey}>
        <div className="d-flex justify-content-between align-items-baseline mb-4">
          <h5>Vocabulary Editor</h5>
          <div className="d-flex gap-2">
            <button className="btn btn-width btn-castleWhite" onClick={()=> window.history.back()}>Cancel</button>
            <button className="btn btn-width btn-castleRed" onClick={()=> handleSave()}>Save</button>
          </div>
        </div>
        <label className="mb-4">Vocabulary Term</label>
        <input type="text"  value={term} className="form-control mb-4" onChange={(e)=>setTerm(e.target.value)}/>
        <label className="mb-4">Definition</label>
        <CKEditor
          editorData={definition}
          setEditorData={setDefinition}
        />
      </div>
      {isOpenCreateFlashcardSet &&
      <CreateFlashcardSetModel
        isOpen={isOpenCreateFlashcardSet}
        onClose={() => setIsOpenCreateFlashcardSet(false)}
        onSave={createFlashcardWithSetAsync}
        showFlashcardOptions={false}
      />
      }
    </>
  );
};



export default AddFlashCard;